import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

// Angular's Validators.email follows the WHATWG spec, which accepts dotless domains such as `user@host`.
// Deliverable addresses also need at least one dot in the domain followed by a TLD of two or more letters.
const DOMAIN_WITH_TLD_PATTERN = /@[^@\s]+\.[a-z]{2,}$/i;

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const value = (control.value ?? '').trim();
  if (!value) {
    return null;
  }
  return Validators.email(control) ?? (DOMAIN_WITH_TLD_PATTERN.test(value) ? null : { email: true });
}
